import { render } from "./BusinessModelDriversCard.vue?vue&type=template&id=50ed3ed0&scoped=true&ts=true"
import script from "./BusinessModelDriversCard.vue?vue&type=script&lang=ts"
export * from "./BusinessModelDriversCard.vue?vue&type=script&lang=ts"

import "./BusinessModelDriversCard.vue?vue&type=style&index=0&id=50ed3ed0&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ed3ed0"]])

export default __exports__